import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function ProdutosControladosPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Importação de Produto Controlado'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'approveProdutoListaControlados'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Aprovar itens da lista de Importação de Controlados  '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoControladosAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação de Controlados em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoControladosChefeArea'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação de Controlados processo em Chefe de Área '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoControladosChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação de Controlados processo em Chefe de Departamento '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoControladosDirectoraGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação de Controlados processo em Directora Geral Adjunta'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoControladosDirectorGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação de Controlados processo em Director Geral'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesProdutoControlado'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Reclamações de Produtos Controlados'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
